import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initializeGoogleAnalytics, isGoogleAnalyticsEnabled, trackPageView } from './googleAnalytics';

const GoogleAnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    initializeGoogleAnalytics();
  }, []);

  useEffect(() => {
    if (!isGoogleAnalyticsEnabled()) {
      return;
    }

    trackPageView(`${location.pathname}${location.search}${location.hash}`);
  }, [location.hash, location.pathname, location.search]);

  return null;
};

export default GoogleAnalyticsTracker;
